import { Banner, Box, Card, H2, Separator } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import ClaimedRewardItem from './ClaimedRewardItem';
import { useReferralSenderOffer } from './ReferAFriendProvider';

import { urlBuilder } from '../../Shared/urlBuilder';

const ClaimedRewardsCard: React.FC = () => {
  const { senderOfferFulfillments, hasMaximumInvestingReferrals } = useReferralSenderOffer();

  if (senderOfferFulfillments.length === 0) return null;

  return (
    <Card css={{ p: 'space.400' }}>
      <Card.Header>
        <Box css={{ display: 'flex', justifyContent: 'space-between' }}>
          <H2 variant="title200">Claimed rewards</H2>
          <SambaAutoLink to={urlBuilder.appEarnedRewards.absolute()}>See your rewards</SambaAutoLink>
        </Box>
      </Card.Header>
      <Box css={{ py: 'space.300' }}>
        <Separator />
      </Box>
      <Card.Content>
        {senderOfferFulfillments.map((senderOfferFulfillment, index) => {
          const isLastItemInList = senderOfferFulfillments.length - 1 === index;
          const uniqueKey = `${senderOfferFulfillment.offerName}_${index}`;
          return (
            <div key={uniqueKey}>
              <ClaimedRewardItem {...senderOfferFulfillment} />
              {!isLastItemInList && (
                <Box css={{ py: 'space.300' }}>
                  <Separator />
                </Box>
              )}
            </div>
          );
        })}

        {hasMaximumInvestingReferrals && (
          <Banner>You have no more available rewards but you can continue referring friends.</Banner>
        )}
      </Card.Content>
    </Card>
  );
};

export default ClaimedRewardsCard;
